'use client';
import { createContext, useMemo } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

function _define_property(t, e, o) {
    return e in t ? Object.defineProperty(t, e, {
        value: o,
        enumerable: true,
        configurable: true,
        writable: true
    }) : t[e] = o, t;
}
function _object_spread(t) {
    for(var e = 1; e < arguments.length; e++){
        var o = null != arguments[e] ? arguments[e] : {}, r = Object.keys(o);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(o).filter(function(t) {
            return Object.getOwnPropertyDescriptor(o, t).enumerable;
        }))), r.forEach(function(e) {
            _define_property(t, e, o[e]);
        });
    }
    return t;
}
function useListboxList(t, o, r) {
    return useMemo(()=>({
            listState: r,
            listProps: _object_spread({
                disallowEmptySelection: true,
                shouldFocusOnHover: true,
                shouldSelectOnPressUp: true
            }, t),
            listboxRef: o
        }), [
        r,
        t,
        o
    ]);
}
const SwanListboxListContext = createContext(void 0);
function useSwanListboxListContext() {
    return useNonNullishContext(SwanListboxListContext);
}

export { SwanListboxListContext, useListboxList, useSwanListboxListContext };
